import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/user/membership/list": {
    required: ["userId"],
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  list: (options, args) => apiRequest(options, "/user/membership/list", args),
};
